import React from 'react';
import Texts from '../../../assets/utils/texts';
import { Field, RichText } from '@sitecore-jss/sitecore-jss-nextjs';

type LocationBioProps = {
	About?: Field<string>;
	LocationName?: Field<string>;
	LocationTypes?: Array<{
		name: string;
		fields?: {
			Description?: Field<string>;
		};
	}>;
	ServicesOffered?: Field<string>;
};

const LocationBio = (props: LocationBioProps): JSX.Element => {
	const { About, LocationName, LocationTypes, ServicesOffered } = props;

	const locationTypeName = LocationTypes?.[0]?.name;
	
	return (
		<div className="location-result location-bio location-mobile-print active">

			{(LocationName?.value || locationTypeName) && (
				<div
					id="introduction"
					itemProp="hospitalAffiliation"
					itemType="http://schema.org/Hospital"
				>
				
					{locationTypeName && <span className="location-type osf-nav-top-level">{locationTypeName}</span>}
					{LocationName?.value && (
						<h1 className="location-longname osf-h3" itemProp="name">
							{LocationName.value}
						</h1>
					)}
				</div>
			)}

			{About?.value && (
				<div id="about" className="profile-section location-about osf-h3">
					<RichText field={About} />
				</div>
			)}

			{ServicesOffered?.value && (
				<div id="services" data-module="" className="profile-section location-services ">
						<h2 className="osf-inner-h2">{Texts.ServicesOffered}</h2>
						<RichText field={ServicesOffered} />
				</div>
			)}

		</div>
	);
};

export default LocationBio;
